'use strict';
var ResultIntegrationType;
(function (ResultIntegrationType) {
    ResultIntegrationType["Layover"] = "layover";
    ResultIntegrationType["Fullscreen"] = "fullscreen";
    ResultIntegrationType["Embed"] = "embed";
})(ResultIntegrationType || (ResultIntegrationType = {}));
export default ResultIntegrationType;
